import SMRestClient from 'lib/SMRestClient';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMReservationStatusResource {
  
  static getReservationStatuses(queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const apiClient = new SMRestClient();
    apiClient.get("/1/reservation_statuses.json" + q).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

}
export default SMReservationStatusResource;



// WEBPACK FOOTER //
// ./app/javascript/resources/SMReservationStatusResource.js